import * as React from 'react';
import { Grid, Container, Button } from '@material-ui/core'; // Importamos Button
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';
import { typeQuotation } from './resources';

const Home: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  React.useEffect(() => {
    document.title = 'Inicio';
  }, []);

  return (
    <Container maxWidth={false} disableGutters className={classes.container}>
      <Grid container spacing={0} className={classes.gridContainer}>
        {typeQuotation.map((type: ICardContent) => (
          <Grid item xs={12} sm={4} key={type.id} className={classes.gridItem}>
            <div className={classes.image} style={{ backgroundImage: `url(${type.image})` }}>
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={() => history.push(`${type.path}`)}>
                  Cotizar
                </Button>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Home;
